import { render, staticRenderFns } from "./order-info.vue?vue&type=template&id=49620e78&scoped=true&"
import script from "./order-info.vue?vue&type=script&lang=ts&"
export * from "./order-info.vue?vue&type=script&lang=ts&"
import style0 from "./order-info.vue?vue&type=style&index=0&id=49620e78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../16/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49620e78",
  null
  
)

export default component.exports